import { useContext, useMemo } from "react";

// contexts
import { CartContext } from "@cart-client/contexts/CartContext";
import { UpdateCartContext } from "@cart-client/contexts/UpdateCartContext";

// types and hooks
import { CouponDetails } from "@swiggy-private/cart-types";

// utils
import { getNestedValue, isEmpty } from "@swiggy-private/js-utils";

export const useModalVisibility = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;

    const { showCouponModal, showDelightPopup, showM2Chalfcard } = useContext(UpdateCartContext);

    const isAutoAddCouponApplied = useMemo(() => {
        const couponDetails: CouponDetails = getNestedValue(cartResponse, "data.coupon_details");
        return !isEmpty(couponDetails?.is_coupon_auto_applied);
    }, [cartResponse]);

    const isAnyModalVisible = useMemo(() => {
        return isAutoAddCouponApplied || showCouponModal || showDelightPopup || showM2Chalfcard;
    }, [isAutoAddCouponApplied, showCouponModal, showDelightPopup, showM2Chalfcard]);

    return { isAnyModalVisible };
};
